export default "__VITE_ASSET__Dpb5QYPg__"